import { useCallback, useRef, useState } from "react";

export const useOverflowTooltip = () => {
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);

  const onMouseEnter = useCallback(() => {
    const el = ref.current;
    if (
      el &&
      (el.scrollWidth > el.clientWidth || el.scrollHeight > el.clientHeight)
    ) {
      setVisible(true);
    }
  }, []);

  const onMouseLeave = useCallback(() => {
    setVisible(false);
  }, []);

  return { ref, visible, onMouseEnter, onMouseLeave };
};
